module.exports = __webpack_public_path__ + "img/lapiz.f221546e.png";